/**
 * Create default object from yup schema.
 */
export function defaultObject(schema) {
  const {fields} = schema.describe();
  let initialValues = {};
  Object.keys(fields).forEach(
    (field) => (initialValues[field] = defaultValue(fields[field].type)),
  );
  return initialValues;
}

/**
 * Create default object from yup schema.
 */
export function fields(schema) {
  const {fields} = schema.describe();
  return Object.keys(fields).map((field) => {
    let {type, label, tests} = fields[field];
    return {type, label, field, tests};
  });
}

/**
 * Default yup values.
 */
export function defaultValue(type) {
  // eslint-disable-next-line default-case
  switch (type) {
    case 'string':
      return '';
    case 'number':
      return 0;
    case 'boolean':
      return false;
    case 'date':
      return new Date();
    case 'object':
      return {};
  }
}
